import { userListHeaderStyles } from "@insite/content-library/Widgets/UserList/UserListHeader";
import { userListUsersTableStyles } from "@insite/content-library/Widgets/UserList/UserListUsersTable";
import { userSetupStatusStyles } from "@insite/content-library/Widgets/UserSetup/UserSetupStatus";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";


userListHeaderStyles.userCountText = {
    css: css`
        color: ${getColor("secondary")};
    `,
};

userListUsersTableStyles.usernameHeader = {
    css: css`
        span {
            font-size: 1rem;
            color: ${getColor("primary")};
        }
    `,
};

userListUsersTableStyles.nameHeader = {
    css: css`
        span {
            font-size: 1rem;
            color: ${getColor("primary")};
        }
    `,
};
userListUsersTableStyles.emailHeader = {
    css: css`
        span {
            font-size: 1rem;
            color: ${getColor("primary")};
        }
    `,
};
userListUsersTableStyles.statusHeader = {
    css: css`
        span {
            font-size: 1rem;
            color: ${getColor("primary")};
        }
    `,
};
userListUsersTableStyles.roleHeader = {
    css: css`
        span {
            font-size: 1rem;
            color: ${getColor("primary")};
        }
    `,
};

userListUsersTableStyles.lastSignInHeader = {
    css: css`
        span {
            font-size: 1rem;
            color: ${getColor("primary")};
        }
    `,
};

userListUsersTableStyles.lastSignInCells={
    css: css`
        font-size: 1rem;
        color: ${getColor("secondary")};
`,
}

userListUsersTableStyles.usernameCells = {
    css: css`
        span {
            font-size: 1rem;
            color: ${getColor("primary")};
        }
    `,
};

userListUsersTableStyles.nameCells = {
    css: css`
        span {
            font-size: 1rem;
            color: ${getColor("secondary")};
        }
    `,
};

userListUsersTableStyles.emailCells = {
    css: css`
        span {
            font-size: 1rem;
            color: ${getColor("secondary")};
        }
    `,
};

userListUsersTableStyles.roleCells = {
    css: css`
        span {
            font-size: 1rem;
            color: ${getColor("secondary")};
        }
    `,
};

userListUsersTableStyles.statusCells = {
    css: css`
            font-size: 1rem;
            color: ${getColor("secondary")};
    `,
};


userSetupStatusStyles.activationStatus = {
    css: css`
        font-size: 1rem !important;
        color: ${getColor("secondary")};
        [class^="TypographyStyle"]{
            font-size: 1rem;
        }
    `,
};

userSetupStatusStyles.lastSignInLabel = {
    css: css`
        font-size: 1rem;
        color: ${getColor("secondary")};
    `,
};

userSetupStatusStyles.lastSignInText={
    css: css`
    color: ${getColor("secondary")};
`,
}



